import React from "react";
import PropTypes from "prop-types";
import { localize } from "redux-i18n";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Col,
  FormGroup,
  Label,
} from "@components";
import { Field, reduxForm, formPropTypes } from "redux-form";
import { Dropdown } from "@components/form";

export class ReassignStaffGroupModal extends React.Component {
  render() {
    return (
      <Modal>
        <Form onSubmit={this.props.handleSubmit}>
          <ModalHeader toggle={this.props.onDismissHandler}>
            {this.props.t("REASSIGN_EMPLOYEES")}
          </ModalHeader>
          <ModalBody>
            <div className="py-2">
              {this.props.t("REASSIGN_EMPLOYEES_TO_STAFF_GROUP", {
                employeesCount: this.props.numberOfEmployees,
                staffGroupName: this.props.staffGroupName,
              })}
            </div>
            <FormGroup className="py-3 border-top text-left">
              <Col sm={10} className={"offset-sm-1"}>
                <Label for="staffGroup">{this.props.t("STAFF_GROUP")}</Label>
                <Field
                  id="staffGroup"
                  name="staffGroup"
                  placeholder={this.props.t("SELECT")}
                  component={Dropdown}
                  options={this.props.options}
                />
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end">
            <Button color="secondary" onClick={this.props.onDismissHandler} data-dismiss="modal">
              {this.props.t("CANCEL")}
            </Button>
            <Button type="submit">{this.props.t("REASSIGN")}</Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

ReassignStaffGroupModal.propTypes = {
  ...formPropTypes,
  isLoading: PropTypes.bool,
  onDismissHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  numberOfEmployees: PropTypes.number,
  disableStaffGroupName: PropTypes.string,
  options: PropTypes.array.isRequired,
};

export default reduxForm({
  form: "staff-groups",
})(localize()(ReassignStaffGroupModal));
